import { Border3 } from '@tanium/react-theme-definition';

export const Divider = Border3;
